export default __webpack_public_path__ + "static/large-cabin-bedroom-4252fb1237c4442571599fd1261a44ef.jpg";